import { Empty, Modal, Spin } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentsActions } from '../../store/actions/documents.actions';
import useDocsIdByBind from '../../queries/useDocsIdByBind';
import Body from './components/Body/Body';
import CreateConnection from './components/CreateConnection/CreateConnection';

const RelatedDocsModal = () => {
  const dispatch = useDispatch();

  const doc = useSelector(
    (state) => state.documentsStore.relatedDocsModalVisible
  );

  const { data: relatedObjects = [], isFetching } = useDocsIdByBind(doc?.id);

  const handleClose = () => {
    dispatch(documentsActions.setRelatedDocsModal(null));
  };

  return (
    <Modal
      visible={!!doc}
      title="Связанные объекты"
      footer={null}
      onCancel={handleClose}
      width="700px"
    >
      <CreateConnection />
      <Spin spinning={isFetching}>
        {!!relatedObjects?.length ? (
          <Body relatedObjects={relatedObjects} />
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Spin>
    </Modal>
  );
};

export default RelatedDocsModal;
